import { PlaceholderPage } from "./PlaceholderPage";

export function SharePage() {
	return <PlaceholderPage titleKey="home.nav.share" analyticsName="share" />;
}
